import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import AmenitiesLayer from "../../components/Amenities/AmenitiesLayer";


const AmenitiesListPage = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Amenities" />

        {/* UsersListLayer */}
        <AmenitiesLayer />

      </MasterLayout>

    </>
  );
};

export default AmenitiesListPage; 
